"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPluKey = exports.usePluConfigToVendorConfigAdapter = void 0;
const schemata_1 = require("../schemata");
const isPosDataServiceMode = (serviceMode) => {
    return Object.values(schemata_1.PosDataServiceMode).includes(serviceMode);
};
const isReference = (object) => {
    return typeof (object === null || object === void 0 ? void 0 : object._ref) === 'string';
};
const isPosIntegration = (object) => {
    return typeof (object === null || object === void 0 ? void 0 : object.name) === 'string';
};
const isCartServiceMode = (serviceMode) => {
    return Object.values(schemata_1.CartServiceMode).includes(serviceMode);
};
const isServiceModeDelivery = (serviceMode) => serviceMode === schemata_1.PosDataServiceMode.delivery;
const genericServiceModeToPosDataServiceMode = (serviceMode) => {
    if (isCartServiceMode(serviceMode)) {
        if (serviceMode === schemata_1.CartServiceMode.cateringDelivery ||
            serviceMode === schemata_1.CartServiceMode.delivery) {
            return schemata_1.PosDataServiceMode.delivery;
        }
        return schemata_1.PosDataServiceMode.pickup;
    }
    else if (isPosDataServiceMode(serviceMode)) {
        return serviceMode;
    }
    else {
        throw new Error(`[PLU Configs] Trying to use the adapter with an invalid service mode ${serviceMode}`);
    }
};
const posVendorToPluConfigPosVendor = {
    [schemata_1.VendorConfigPosVendors.CARROLS]: schemata_1.PluConfigPosVendors.CARROLS,
    [schemata_1.VendorConfigPosVendors.NCR]: schemata_1.PluConfigPosVendors.NCR,
    [schemata_1.VendorConfigPosVendors.PARTNER]: schemata_1.PluConfigPosVendors.PARTNER,
    [schemata_1.VendorConfigPosVendors.PRODUCT_NUMBER]: schemata_1.PluConfigPosVendors.PRODUCT_NUMBER,
    [schemata_1.VendorConfigPosVendors.QDI]: schemata_1.PluConfigPosVendors.QDI,
    [schemata_1.VendorConfigPosVendors.QST]: schemata_1.PluConfigPosVendors.QST,
    [schemata_1.VendorConfigPosVendors.OHEICS]: schemata_1.PluConfigPosVendors.OHEICS,
    [schemata_1.VendorConfigPosVendors.RPOS]: schemata_1.PluConfigPosVendors.RPOS,
    [schemata_1.VendorConfigPosVendors.SICOM]: schemata_1.PluConfigPosVendors.SICOM,
    [schemata_1.VendorConfigPosVendors.SIMPLY_DELIVERY]: schemata_1.PluConfigPosVendors.SIMPLY_DELIVERY,
    [schemata_1.VendorConfigPosVendors.TABLET]: schemata_1.PluConfigPosVendors.TABLET,
    [schemata_1.VendorConfigPosVendors.TOSHIBA_LOYALTY]: schemata_1.PluConfigPosVendors.TOSHIBA_LOYALTY,
    [schemata_1.VendorConfigPosVendors.CARROLS_DELIVERY]: schemata_1.PluConfigPosVendors.CARROLS,
    [schemata_1.VendorConfigPosVendors.NCR_DELIVERY]: schemata_1.PluConfigPosVendors.NCR,
    [schemata_1.VendorConfigPosVendors.PARTNER_DELIVERY]: schemata_1.PluConfigPosVendors.PARTNER,
    [schemata_1.VendorConfigPosVendors.PRODUCT_NUMBER_DELIVERY]: schemata_1.PluConfigPosVendors.PRODUCT_NUMBER,
    [schemata_1.VendorConfigPosVendors.QDI_DELIVERY]: schemata_1.PluConfigPosVendors.QDI,
    [schemata_1.VendorConfigPosVendors.QST_DELIVERY]: schemata_1.PluConfigPosVendors.QST,
    [schemata_1.VendorConfigPosVendors.OHEICS_DELIVERY]: schemata_1.PluConfigPosVendors.OHEICS,
    [schemata_1.VendorConfigPosVendors.RPOS_DELIVERY]: schemata_1.PluConfigPosVendors.RPOS,
    [schemata_1.VendorConfigPosVendors.SICOM_DELIVERY]: schemata_1.PluConfigPosVendors.SICOM,
    [schemata_1.VendorConfigPosVendors.SIMPLY_DELIVERY_DELIVERY]: schemata_1.PluConfigPosVendors.SIMPLY_DELIVERY,
    [schemata_1.VendorConfigPosVendors.TABLET_DELIVERY]: schemata_1.PluConfigPosVendors.TABLET,
    [schemata_1.PosVendor.CARROLS]: schemata_1.PluConfigPosVendors.CARROLS,
    [schemata_1.PosVendor.CONNECTOR]: schemata_1.PluConfigPosVendors.CONNECTOR,
    [schemata_1.PosVendor.NCR]: schemata_1.PluConfigPosVendors.NCR,
    [schemata_1.PosVendor.OHEICS]: schemata_1.PluConfigPosVendors.OHEICS,
    [schemata_1.PosVendor.PARTNER]: schemata_1.PluConfigPosVendors.PARTNER,
    [schemata_1.PosVendor.PRODUCT_NUMBER]: schemata_1.PluConfigPosVendors.PRODUCT_NUMBER,
    [schemata_1.PosVendor.QDI]: schemata_1.PluConfigPosVendors.QDI,
    [schemata_1.PosVendor.QST]: schemata_1.PluConfigPosVendors.QST,
    [schemata_1.PosVendor.RPOS]: schemata_1.PluConfigPosVendors.RPOS,
    [schemata_1.PosVendor.SICOM]: schemata_1.PluConfigPosVendors.SICOM,
    [schemata_1.PosVendor.SIMPLY_DELIVERY]: schemata_1.PluConfigPosVendors.SIMPLY_DELIVERY,
    [schemata_1.PosVendor.TABLET]: schemata_1.PluConfigPosVendors.TABLET,
    [schemata_1.PosVendor.TOSHIBA_LOYALTY]: schemata_1.PluConfigPosVendors.TOSHIBA_LOYALTY,
};
/**
 * For a set of posVendor, serviceMode and posIntegration, validates and converts the params
 * to PluConfig compatible parameters(e.g PARTNER to partner, eatIn to pickup). If this conversion
 * can't be made, it will throw an error.
 *
 * Afterwards, returns adapters for single object and array/deep object conversion(looks into nested properties).
 *
 * When overriding VendorConfigs with PluConfigs, PosVendors that are not relevant for the store-serviceMode
 * combination will be removed. For example: in a Partner store on pickup serviceMode, vendorConfigs for RPOS, NCR, etc
 * will be removed.
 *
 * If the object does not have a PluConfig, the vendorConfig will be set as undefined and a warn will be raised.
 * This is to give visibility on configuration issues and avoid half usage of vendorConfigs/half usage of pluConfigs.
 * It should either be one or the other.
 * @param {ConversionParameters} params
 */
const usePluConfigToVendorConfigAdapter = (params, options) => {
    /**
     * The goal is to allow consumers to send any set of serviceMode/Pos they have,
     * just so we don't need to have this sorts of conversion logic scattered all over the place.
     *
     * It also avoids consumers to perform invalid conversions.
     */
    const normalizedParams = normalizeParams(params);
    const { omitVendorConfigsType } = options !== null && options !== void 0 ? options : {};
    /**
     * Receives an object and overrides it's vendorConfigs with
     * the PluConfigs based on previously provided parameters.
     * @param {any} object
     */
    const convert = (object) => {
        setVendorConfig(object, normalizedParams, omitVendorConfigsType);
        delete object.pluConfigs;
    };
    /**
     * Receives an object and recursively looks into every key of the object to override
     * the vendorConfigs in place with the previously provided parameters.
     *
     * @param {any} object
     */
    const convertDeep = (object) => {
        if ((object === null || object === void 0 ? void 0 : object.vendorConfigs) || (object === null || object === void 0 ? void 0 : object.pluConfigs)) {
            convert(object);
        }
        for (const key in object) {
            if (Array.isArray(object[key])) {
                for (const element of object[key]) {
                    convertDeep(element);
                }
            }
            else if (typeof object[key] === 'object') {
                convertDeep(object[key]);
            }
        }
    };
    return {
        convert,
        convertDeep,
    };
};
exports.usePluConfigToVendorConfigAdapter = usePluConfigToVendorConfigAdapter;
const pickPluConfig = (object, params) => {
    const { posVendor, serviceMode, posIntegration, posIntegrationReference } = params;
    if (!object.pluConfigs) {
        return;
    }
    const pluConfig = object.pluConfigs[posVendor.toLowerCase()];
    if (!pluConfig) {
        return;
    }
    const isPartnerPosVendor = posVendor === schemata_1.PluConfigPosVendors.PARTNER;
    /**
     * The selected config, for regular vendors, must match only ServiceMode.
     *
     * For Partner Pos Vendor, must match the posIntegration as well.
     *
     * To keep things simlper for consumers, both references & the whole partner group is accepted.
     */
    const selectedConfig = pluConfig.find((element) => {
        const hasSameServiceMode = element.serviceMode === serviceMode;
        const elementPosIntegration = element.posIntegration;
        if (!isPartnerPosVendor) {
            return hasSameServiceMode;
        }
        /**
         * The way sanity references work, it's possible to compare
         * a reference _ref to the actual element _id. So we can actually
         * check the element partner group reference against the partnerGrup object
         * or the posIntegration reference against the element partner group object :)
         */
        return (hasSameServiceMode &&
            (arePropertiesDefinedAndEqual(elementPosIntegration === null || elementPosIntegration === void 0 ? void 0 : elementPosIntegration.name, posIntegration === null || posIntegration === void 0 ? void 0 : posIntegration.name) ||
                arePropertiesDefinedAndEqual(elementPosIntegration === null || elementPosIntegration === void 0 ? void 0 : elementPosIntegration._ref, posIntegrationReference === null || posIntegrationReference === void 0 ? void 0 : posIntegrationReference._ref) ||
                arePropertiesDefinedAndEqual(elementPosIntegration === null || elementPosIntegration === void 0 ? void 0 : elementPosIntegration._ref, posIntegration === null || posIntegration === void 0 ? void 0 : posIntegration._id) ||
                arePropertiesDefinedAndEqual(elementPosIntegration === null || elementPosIntegration === void 0 ? void 0 : elementPosIntegration._id, posIntegrationReference === null || posIntegrationReference === void 0 ? void 0 : posIntegrationReference._ref)));
    });
    if (!selectedConfig) {
        return;
    }
    return selectedConfig === null || selectedConfig === void 0 ? void 0 : selectedConfig.vendorConfig;
};
const setVendorConfig = (object, params, omitVendorConfigsType = false) => {
    const { posVendor, serviceMode } = params;
    /**
     * If a serviceMode is not provided, convert both serviceModes!
     */
    if (!serviceMode) {
        const pickupVendorConfig = pickPluConfig(object, {
            ...params,
            serviceMode: schemata_1.PosDataServiceMode.pickup,
        });
        const deliveryVendorConfig = pickPluConfig(object, {
            ...params,
            serviceMode: schemata_1.PosDataServiceMode.delivery,
        });
        const pickupPluKey = (0, exports.getPluKey)(posVendor, schemata_1.PosDataServiceMode.pickup);
        const deliveryPluKey = (0, exports.getPluKey)(posVendor, schemata_1.PosDataServiceMode.delivery);
        object.vendorConfigs = {
            [deliveryPluKey]: deliveryVendorConfig,
            [pickupPluKey]: pickupVendorConfig,
        };
    }
    else {
        const vendorConfig = pickPluConfig(object, params);
        const pluKey = (0, exports.getPluKey)(posVendor, serviceMode);
        object.vendorConfigs = {
            [pluKey]: vendorConfig,
        };
    }
    /**
     * A few consumers of the adapter behave slightly different.
     * E.g.
     * - menu-service store-menu types require the _type: vendorConfigs
     * - whitelabel breaks if _type is defined under vendorConfigs
     *
     * Early on, to avoid changing types and pottentialy break interfaces
     * across a lot of services, I'm defining this option to be passed to
     * usePluConfigToVendorConfigAdapter.
     */
    if (!omitVendorConfigsType) {
        object.vendorConfigs._type = 'vendorConfigs';
    }
};
const normalizeParams = (params) => {
    const { posVendor, serviceMode, posIntegration: payloadPosIntegration } = params;
    const normalizedServiceMode = serviceMode
        ? genericServiceModeToPosDataServiceMode(serviceMode)
        : undefined;
    const normalizedPosVendor = posVendorToPluConfigPosVendor[posVendor];
    if (!normalizedPosVendor) {
        throw new Error(`[PLU Configs] Invalid Pos Vendor ${posVendor}`);
    }
    if (normalizedPosVendor === schemata_1.PluConfigPosVendors.PARTNER && !payloadPosIntegration) {
        throw new Error('[PluConfigs] Partner POS requires an integration group to be defined');
    }
    const posIntegrationReference = isReference(payloadPosIntegration)
        ? payloadPosIntegration
        : undefined;
    const posIntegration = isPosIntegration(payloadPosIntegration)
        ? payloadPosIntegration
        : undefined;
    return {
        posIntegration,
        posIntegrationReference,
        posVendor: normalizedPosVendor,
        serviceMode: normalizedServiceMode,
    };
};
const getPluKey = (posVendor, serviceMode) => {
    switch (posVendor) {
        case schemata_1.PosVendor.CARROLS:
        case schemata_1.PluConfigPosVendors.CARROLS:
            return isServiceModeDelivery(serviceMode)
                ? schemata_1.VendorConfigPosVendors.CARROLS_DELIVERY
                : schemata_1.VendorConfigPosVendors.CARROLS;
        case schemata_1.PosVendor.CONNECTOR:
        case schemata_1.PluConfigPosVendors.CONNECTOR:
        case schemata_1.PosVendor.PRODUCT_NUMBER:
        case schemata_1.PluConfigPosVendors.PRODUCT_NUMBER:
            // connector is product number
            return isServiceModeDelivery(serviceMode)
                ? schemata_1.VendorConfigPosVendors.PRODUCT_NUMBER_DELIVERY
                : schemata_1.VendorConfigPosVendors.PRODUCT_NUMBER;
        case schemata_1.PosVendor.NCR:
        case schemata_1.PluConfigPosVendors.NCR:
            return isServiceModeDelivery(serviceMode)
                ? schemata_1.VendorConfigPosVendors.NCR_DELIVERY
                : schemata_1.VendorConfigPosVendors.NCR;
        case schemata_1.PosVendor.OHEICS:
        case schemata_1.PluConfigPosVendors.OHEICS:
            return isServiceModeDelivery(serviceMode)
                ? schemata_1.VendorConfigPosVendors.OHEICS_DELIVERY
                : schemata_1.VendorConfigPosVendors.OHEICS;
        case schemata_1.PosVendor.QDI:
        case schemata_1.PluConfigPosVendors.QDI:
            return isServiceModeDelivery(serviceMode)
                ? schemata_1.VendorConfigPosVendors.QDI_DELIVERY
                : schemata_1.VendorConfigPosVendors.QDI;
        case schemata_1.PosVendor.QST:
        case schemata_1.PluConfigPosVendors.QST:
            return isServiceModeDelivery(serviceMode)
                ? schemata_1.VendorConfigPosVendors.QST_DELIVERY
                : schemata_1.VendorConfigPosVendors.QST;
        case schemata_1.PosVendor.RPOS:
        case schemata_1.PluConfigPosVendors.RPOS:
            return isServiceModeDelivery(serviceMode)
                ? schemata_1.VendorConfigPosVendors.RPOS_DELIVERY
                : schemata_1.VendorConfigPosVendors.RPOS;
        case schemata_1.PosVendor.SICOM:
        case schemata_1.PluConfigPosVendors.SICOM:
            return isServiceModeDelivery(serviceMode)
                ? schemata_1.VendorConfigPosVendors.SICOM_DELIVERY
                : schemata_1.VendorConfigPosVendors.SICOM;
        case schemata_1.PosVendor.SIMPLY_DELIVERY:
        case schemata_1.PluConfigPosVendors.SIMPLY_DELIVERY:
            return isServiceModeDelivery(serviceMode)
                ? schemata_1.VendorConfigPosVendors.SIMPLY_DELIVERY_DELIVERY
                : schemata_1.VendorConfigPosVendors.SIMPLY_DELIVERY;
        case schemata_1.PosVendor.TABLET:
        case schemata_1.PluConfigPosVendors.TABLET:
            return isServiceModeDelivery(serviceMode)
                ? schemata_1.VendorConfigPosVendors.TABLET_DELIVERY
                : schemata_1.VendorConfigPosVendors.TABLET;
        case schemata_1.PosVendor.TOSHIBA_LOYALTY:
        case schemata_1.PluConfigPosVendors.TOSHIBA_LOYALTY:
            return schemata_1.VendorConfigPosVendors.TOSHIBA_LOYALTY;
        case schemata_1.PosVendor.PARTNER:
        case schemata_1.PluConfigPosVendors.PARTNER:
            return isServiceModeDelivery(serviceMode)
                ? schemata_1.VendorConfigPosVendors.PARTNER_DELIVERY
                : schemata_1.VendorConfigPosVendors.PARTNER;
    }
};
exports.getPluKey = getPluKey;
const arePropertiesDefinedAndEqual = (property1, property2) => {
    return property1 !== undefined && property2 !== undefined && property1 === property2;
};
//# sourceMappingURL=plu-config-to-vendor-config-adapter.js.map